export class CancelError extends Error {}
